











import {defineComponent} from '@vue/composition-api'

export default defineComponent({
    name: "CloseButtonAtom",
    props: {
        ariaLabel: {
            type: String
        },
        backgroundColor: {
            type: String,
            default: 'vuw-dynamic-bg-color-3'
        }
    }
})
